import apiSlice from "./apiSlice";
const keyPMSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    editKeyPM: builder.mutation({
      query: ({ id, body }) => ({
        url: `/p-and-m/${id}`,
        method: "PUT",
        body,
      }),
    }),
    getPendingPM: builder.query({
      query: (req) => ({
        url: `p-and-m/GetWorkFlows`,
        params: req,
      }),
    }),
    updateWorkFlowPM: builder.mutation({
      query: (body) => ({
        url: `p-and-m/UpdateWorkflow`,
        method: "POST",
        body,
      }),
    }),
    getPMDetail: builder.query({
      query: (req) => ({
        url: `p-and-m/${req}`
      }),
    }),
  }),
});

export const {
  useEditKeyPMMutation,
  useUpdateWorkFlowPMMutation,
  useGetPendingPMQuery,
  useGetPMDetailQuery,
} = keyPMSlice;
